import { Button, ButtonGroup, Divider } from '@blueprintjs/core'
import * as React from 'react'
import ReactTable from 'react-table'
import { UprightStyle } from '../../types'

const styles: UprightStyle = {
  container: { display: 'flex', justifyContent: 'center', paddingBottom: 20, marginTop: 20 },
  info: { margin: `10px 20px 10px 20px`, fontWeight: 600 },
  button: { width: 102, borderRadius: 3 }
}

// An incomplete set of ReactTable props
interface TableProps {
  columns: any
  data: any
  resizable?: boolean
  sortable?: boolean
  SubComponent?: JSX.Element | string | ((row: any) => any)
  onExpandedChange?: (e) => void // required if using custom cell expansion management
  expanded?: { [key: number]: boolean } // required if using custom cell expansion management
}

interface Props {
  tableProps: TableProps
  pageSize: number
  dataLabel: string // description for the pagination text at the bottom of the table
  setExpanded?: (expandedObj: { [key: number]: any }) => void // if using custom cell expansion management, used for resetting expanded cells after paging
}

export const DrawerTable: React.FC<Props> = ({ tableProps, pageSize, dataLabel, setExpanded }) => {
  const [page, setPage] = React.useState(0)

  const currentPageStart = page * pageSize + 1
  const currentPageEnd = Math.min((page + 1) * pageSize, tableProps.data.length)

  const maxPages = React.useMemo(() => {
    // Round up so users can see the last page
    return Math.ceil((tableProps.data.length * 1.0) / pageSize) || 0
  }, [tableProps.data.length, pageSize])

  return (
    <>
      <ReactTable
        {...tableProps}
        page={page}
        pageSize={pageSize}
        className="-striped"
        showPageSizeOptions={false}
        minRows={1}
        showPagination={false}
      />
      <Divider />
      <ButtonGroup style={styles.container}>
        <Button
          onClick={() => {
            setPage(page - 1)
            if (typeof setExpanded === 'function') setExpanded({})
          }}
          disabled={page === 0}
          style={styles.button}
        >
          Previous
        </Button>
        <div
          style={styles.info}
        >{`${currentPageStart} - ${currentPageEnd} of ${tableProps.data.length} ${dataLabel}`}</div>
        <Button
          onClick={() => {
            setPage(page + 1)
            if (typeof setExpanded === 'function') setExpanded({})
          }}
          disabled={page >= maxPages - 1}
          style={styles.button}
        >
          Next
        </Button>
      </ButtonGroup>
    </>
  )
}
